function Error({ error }) {
	return <p>{typeof error === 'string' ? error : JSON.stringify(error)}</p>
}

export default Error